/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 07.09.2016.
 */

import ShowcaseSearch from './showcase-search';

export default ShowcaseSearch;



// WEBPACK FOOTER //
// ./src/containers/ShowcaseSearch/index.js